// src/api/gus.ts
// Integracja z API GUS przez backend

export interface CompanyData {
  nip: string;
  name: string;
  address: string;
  email?: string;
  phone?: string;
  regon?: string;
  wojewodztwo?: string;
  powiat?: string;
  gmina?: string;
}

// Funkcja do pobierania danych z GUS przez backend
export const fetchCompanyData = async (nip: string): Promise<CompanyData | null> => {
  try {
    const cleanNip = nip.replace(/[-\s]/g, '');
    
    console.log('Pobieranie danych z GUS dla NIP:', cleanNip);

    // Określ URL backendu w zależności od środowiska
    const backendUrl = import.meta.env.VITE_API_URL || 
                      (import.meta.env.DEV ? 'http://localhost:3001' : 'https://api.plexisystem.pl');
    
    const response = await fetch(`${backendUrl}/api/gus/${cleanNip}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
      },
    });

    console.log('Status odpowiedzi:', response.status);
    
    if (!response.ok) {
      if (response.status === 404) {
        console.log('Firma nie znaleziona w GUS');
        return null;
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    console.log('Dane z GUS:', data);
    
    // Upewnij się, że wszystkie pola są stringami lub puste
    return {
      nip: cleanNip,
      name: typeof data.name === 'string' ? data.name : '',
      address: typeof data.address === 'string' ? data.address : '',
      regon: typeof data.regon === 'string' ? data.regon : '',
      email: typeof data.email === 'string' ? data.email : '',
      phone: typeof data.phone === 'string' ? data.phone : '',
      wojewodztwo: typeof data.wojewodztwo === 'string' ? data.wojewodztwo : '',
      powiat: typeof data.powiat === 'string' ? data.powiat : '',
      gmina: typeof data.gmina === 'string' ? data.gmina : '',
    };
    
  } catch (error) {
    console.error('Błąd pobierania danych z GUS:', error);
    
    // Dane testowe jako fallback
    const testData: Record<string, CompanyData> = {
      '5252344078': {
        nip: '5252344078',
        name: 'PLEXISYSTEM ŁUKASZ SIKORRA',
        address: 'ul. Kartuska 145B lok. 1, 80-122 Gdańsk',
        regon: '146866569',
        wojewodztwo: 'POMORSKIE',
        powiat: 'Gdańsk',
        gmina: 'Gdańsk',
        email: '',
        phone: ''
      },
      '5882396272': {
        nip: '5882396272',
        name: 'PlexiSystem S.C.',
        address: 'Ks. Dr. Leona Heyke 11, 84-206 Nowy Dwór Wejherowski',
        regon: '123456789',
        wojewodztwo: 'pomorskie',
        powiat: 'wejherowski',
        gmina: 'Wejherowo'
      }
    };
    
    return testData[nip.replace(/[-\s]/g, '')] || null;
  }
};
